export const SHOW_PARENTS_DEFAULT = true;

export const STORE_ORDER_LIMIT = 800.00;

export const vbConfig = {

  procurement: {
    autoSyncStocks: true,
    order: {
      default_title: 'Bestellung',
      default_opening: '<p>Sehr geehrte Damen und Herren,<\/p>' +
      '<p>bitte bestellen Sie die aufgeführten Artikel auf die angegebene Kunden- und Kommissionsnummer.<\/p>',
      default_ending: '<p>Mit freundlichen Grüßen</p>',
    }
  }

};



// WEBPACK FOOTER //
// ./src/app/configuration.ts